import styled, { keyframes } from "styled-components";

const animation = keyframes`
  0%   { transform: rotate(0); }
  100% { transform: rotate(360deg); }
`;

export const Loader = styled.svg`
  > path {
    animation-name: ${animation};
    animation-iteration-count: infinite;
    animation-duration: 1s;
    transform-origin: center;
    fill: ${(props) => props.color ?? "white"};
  }
`;
